import { OBJECT_NAMES } from '@crm/shared';

/**
 * The standard objects Danat uses. Leads aren't used (deals are created directly as opportunities), so they
 * are left out of every list and picker; nothing is deleted: any lead data stays in the database.
 */
export const SHOWN_OBJECTS = OBJECT_NAMES.filter((o) => o !== 'lead');
